export default "__VITE_ASSET__DzbWELhG__"